// extracted by mini-css-extract-plugin
export default {"SitemapNavigation":"SitemapNavigation_SitemapNavigation__M2VkZ"};